import React, { FC, ReactElement } from 'react';

import styles from './styles.module.scss';

import { ITableRow } from 'types/interfaces';

export const TableRow: FC<ITableRow> = ({ children, className = '' }: ITableRow): ReactElement => (
    <div className={`${styles.tableRow} ${className}`}>{children}</div>
);
